import { TipoDestinatarioEnum } from "@app/shared/enum/tipo-destinatario-enum";
import { RecapitoDTO } from "../anagrafe/recapitoDTO";
import { DipendenteDTO } from "../dipendenteDTO";

export class DestinatarioDipendenteDTO {
  competenza: TipoDestinatarioEnum;

  dipendente: DipendenteDTO;
}
